<div class="info-item"  *ngFor="let item of infoItems; trackBy: trackByIndex" [ngClass]="getClass(item)">
  <div [ngClass]="itemClass(item)">
    <div class="info-item__container info-item__container--label">{{item.key}}</div>
    <div class="info-item__container info-item__container--value">
      <ng-container *ngIf="isMixedRetriever(item); else plainValue">
        <span class="badge badge--mixed">{{item.value}}</span>
      </ng-container>
      <ng-template #plainValue>{{item.value}}</ng-template>
      <ng-container *ngIf="showCodThresholdIcon(item)">
        <app-icon
          class="cod-threshold-icon"
          iconName="eye"
          title="COD Threshold"
          (click)="onCodThresholdIconClick($event, codThresholdPopover)">
        </app-icon>
        <app-popover #codThresholdPopover>
          <div class="cod-threshold-popover">
            <div class="cod-threshold-popover__header">
              <span class="cod-threshold-popover__title">COD Threshold</span>
              <span class="cod-threshold-popover__badge" *ngIf="!isLoadingCodThresholds && !hasCodThresholdError">{{ activeProjectCountLabel }}</span>
            </div>
            <div class="cod-threshold-popover__loading" *ngIf="isLoadingCodThresholds">Loading...</div>
            <ng-container *ngIf="!isLoadingCodThresholds">
              <div class="cod-threshold-popover__error" *ngIf="hasCodThresholdError">Unable to load COD thresholds</div>
              <div class="cod-threshold-popover__empty" *ngIf="!hasCodThresholds && !hasCodThresholdError">No COD thresholds configured</div>
              <div class="cod-threshold-popover__table-wrapper" *ngIf="hasCodThresholds && !hasCodThresholdError">
                <table class="cod-threshold-popover__table">
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Threshold</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let codThreshold of codThresholds; trackBy: trackByProjectId">
                      <td>{{ codThreshold.projectName }}</td>
                      <td>{{ codThreshold.codThreshold != null ? (codThreshold.codThreshold | currency) : 'Not Configured' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
        </app-popover>
      </ng-container>
    </div>
  </div>
  <div class="special-handling-flag" *ngIf="item.key=='Address:'">
      <app-icon iconStyle="mrcs-icon"
      iconType="mrcs-icon"
      iconName="special-assignment-address"
      *ngIf="!isSpecialHandling"
      title="Enable Special Handling"
      (click)="specialHandling(true)" ></app-icon>
      <app-icon iconStyle="mrcs-icon"
      iconType="mrcs-icon"
      iconName="special-assignment-address active"
      *ngIf="isSpecialHandling"
      title="Edit Special Handling"
      (click)="specialHandling(false)" ></app-icon>
  </div>
</div>
